<form class="input-filter-container" (click)="$event.stopPropagation()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ filterConfig.label }}</mat-label>
    <input matInput type="text" [attr.aria-label]="filterConfig.label" [formControl]="textInputControl" />
  </mat-form-field>
</form>
